import { useState } from "react";
import { userService } from "../../services";
import { showToastSuccess, showToastError } from "../../utils";

export const useUserActions = () => {
    const [updating, setUpdating] = useState(false);
    const [alertVariant, setAlertVariant] = useState("danger");
    const [statusMessage, setStatusMessage] = useState("");

    const showServiceSuccessResponse = (message: string) => {
        setAlertVariant("success");
        setStatusMessage(message);
        setUpdating(false);
    };

    const showServiceFailureResponse = (
        error: any,
        fallbackMessage: string
    ) => {
        setAlertVariant("danger");
        if (error.status === 400) {
            setStatusMessage(fallbackMessage);
        } else {
            setStatusMessage(error);
        }
        setUpdating(false);
    };

    const disableAndEndAllSessionsForUserWithId = (id: string) => {
        setUpdating(true);
        userService.disableAndEndAllSessionsForUserWithId(id).then(
            (response) => {
                if (response.status !== "Failure") {
                    showToastSuccess("Account disabled.");
                } else {
                    showToastError(`${response.message}, Account disable failed.`);
                }
            },
            (error) => {
                showToastError(`${error}, Account disable failed.`);
            }
        );
    };

    const enableUserWithId = (id: string) => {
        setUpdating(true);
        userService.enableUserWithId(id).then(
            (response) => {
                if (response.status !== "Failure") {
                    showToastSuccess("Account enabled.");
                } else {
                    showToastError(`${response.message}, Account enable failed.`);
                }
            },
            (error) => {
                showToastError(`${error}, Account enable failed.`);
            }
        );
    };

    const resetLockedOutUserWithId = (id: string) => {
        setUpdating(true);
        userService.resetLockedOutUserWithId(id).then(
            (response) => {
                if (response.status !== "Failure") {
                    showToastSuccess("Account unlocked.");
                } else {
                    showToastError(`${response.message}, Account unlock failed.`);
                }
            },
            (error) => {
                showToastError(`${error}, Account unlock failed.`);
            }
        );
    };

    const updateTwoFAIsRequired = (id: string, isRequired: boolean) => {
        setUpdating(true);
        userService.updateTwoFAIsRequired(id, isRequired).then(
            (response) => {
                if (response.status !== "Failure") {
                    showToastSuccess(
                        `Two factor authentication ${
                            isRequired ? "en" : "dis"
                        }abled.`
                    );
                } else {
                    showToastError(`${response.message}, Two factor authentication ${isRequired ? "en" : "dis"}able failed.`);
                }
            },
            (error) => {
                showToastError(`${error}, Two factor authentication ${isRequired ? "en" : "dis"}able failed.`);
            }
        );
    };

    const resetTwoFactorSecretKey = (id: string) => {
        setUpdating(true);
        userService.resetTwoFactorSecretKey(id).then(
            (response) => {
                if (response.status !== "Failure") {
                    showToastSuccess("Two factor authentication reset.");
                } else {
                    showToastError(`${response.message}, Two factor authentication reset failed.`);
                }
            },
            (error) => {
                showToastError(`${error}, Two factor authentication reset failed.`);
            }
        );
    };

    const clearStatusMessage = () => setStatusMessage("");

    return {
        updating,
        alertVariant,
        statusMessage,
        disableAndEndAllSessionsForUserWithId,
        enableUserWithId,
        resetLockedOutUserWithId,
        updateTwoFAIsRequired,
        resetTwoFactorSecretKey,
        clearStatusMessage
    };
};
